import React, { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import css from "./UserPage.module.css";
import { UserContext } from "../../Context/UserContext";
import { CardTrial } from "../Layout/CardTrial";
import { getParticipantFirebase } from "../../Utils/firebaseResearch";
import { ResearchContext } from "../../Context/ResearchContext";

export const UserPage = () => {
  const { resUser, setResUser, sessionTime } = useContext(ResearchContext);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      getParticipantFirebase(id).then(function (result) {
        setResUser(result);
      });
    }
  }, [id]);

  if (!resUser) {
    return <div>Loading...</div>;
  } else if (!resUser.commitmentAgreement) {
    return (
      <section className={css.container}>
        <div onClick={() => navigate("commitment")}>
          <h1>Para iniciar a pesquisa clique abaixo</h1>
          <h2>Termo de Consentimento Livre e Esclarecido</h2>
        </div>
      </section>
    );
  } else if (resUser.commitmentAgreement) {
    return (
      <section className={css.container}>
        {/* <div>{sessionTime}</div> */}

        {resUser.commitmentAgreement && resUser && (
          <div>
            <CardTrial
              icon=""
              title={"Questionário"}
              onClick={() => navigate("inventories")}
              isActive={resUser.phase === 1 ? true : false}
              // isActive={true}
            />
            <CardTrial
              icon=""
              title={"Avaliar palavras"}
              onClick={() => navigate("words")}
              isActive={resUser.phase === 2 ? true : false}
              // isActive={true}
            />
            <CardTrial
              icon=""
              title={"Treino 1"}
              attempts={
                resUser.trialDay === 1
                  ? "tentativa: " + resUser.Trial1attempts
                  : resUser.trialDay === 2
                    ? "tentativa: " + resUser.Trial1attemptsDay2
                    : "tentativa: " + resUser.Trial1attemptsDay3
              }
              onClick={() => navigate("trial1")}
              isActive={resUser.phase === 3 ? true : false}
              // isActive={true}
            />
            <CardTrial
              icon=""
              title={"Teste 1"}
              onClick={() => navigate("test1")}
              isActive={resUser.phase === 4 ? true : false}
              // isActive={true}
            />
            <CardTrial
              icon=""
              title={"Treino 2"}
              attempts={
                resUser.trialDay === 1
                  ? "tentativa: " + resUser.Trial2attempts
                  : resUser.trialDay === 2
                    ? "tentativa: " + resUser.Trial2attemptsDay2
                    : "tentativa: " + resUser.Trial2attemptsDay3
              }
              onClick={() => navigate("trial2")}
              isActive={resUser.phase === 5 ? true : false}
              // isActive={true}
            />
            <CardTrial
              icon=""
              title={"Teste 2"}
              onClick={() => navigate("test2")}
              isActive={resUser.phase === 6 ? true : false}
              // isActive={true}
            />
            <CardTrial
              icon=""
              title={"Fim"}
              onClick={() => navigate("/")}
              isActive={resUser.phase === 7 ? true : false}
              // isActive={true}
            />
          </div>
        )}
      </section>
    );
  } else {
    return <div>Loading...</div>;
  }
};
